/*
 * @Author: MX
 * @Date: 2021-03-26 15:53:27
 * @Description:
 */
import en from './en'
import cn from './cn'
import id from './id'
import kh from './kh'
import my from './my'
import th from './th'
import vi from './vi'
import ar from './ar'
export default {
  en,
  'zh-cn': cn,
  id,
  kh,
  my,
  th,
  vi,
  ar,
}
